module.exports = __webpack_public_path__ + "img/reputationBg.5358342a.png";